import React from 'react';
import {FormattedMessage} from "react-intl";
import PropTypes from 'prop-types';

const FaqTemplate = ({faqSrc, faqMessage}) => {
  return (
    <div>
      {
        faqSrc[faqMessage].map((faq, index) => (
          faq.title ?
            <div key={index}>
              <strong className="Faq-title"><FormattedMessage {...faqSrc[faqMessage][index]['title']['message']} className={'Faq-title'}/></strong>
              <span><FormattedMessage {...faqSrc[faqMessage][index]['subtitle']['message']}/></span>
            </div> :
            <div key={index}>
              <FormattedMessage {...faqSrc[faqMessage][index]['subtitle']['message']}/>
            </div>
        )
        )
      }
    </div>
  );
};

FaqTemplate.prototype = {
  faqSrc: PropTypes.object.isRequired,
  faqMessage: PropTypes.string.isRequired
};

export default FaqTemplate;
